import {NgModule} from '@angular/core';
import {CommonModule} from "@angular/common";
import {CaptchaModule} from "@iw-shared/captcha/captcha.module";
import {FaIconComponent} from "@fortawesome/angular-fontawesome";
import {ReactiveFormsModule} from "@angular/forms";
import {LayoutModule} from "@iw-shared/layout/layout.module";
import {PasswordResetComponent} from "@iw-shared/authentication/components/password-reset/password-reset.component";
import {PasswordLostComponent} from "@iw-shared/authentication/components/password-lost/password-lost.component";
import {LoginComponent} from "@iw-shared/authentication/components/login/login.component";
import {FormModule} from "@iw-shared/form/form.module";

@NgModule({
  declarations: [
    LoginComponent,
    PasswordResetComponent,
    PasswordLostComponent
  ],
  imports: [
    CommonModule,
    CaptchaModule,
    FaIconComponent,
    ReactiveFormsModule,
    LayoutModule,
    FormModule
  ],
  exports: [
    LoginComponent,
    PasswordResetComponent,
    PasswordLostComponent
  ]
})
export class AuthenticationsModule {
}
